<template>
  <div>
    <ul class="lich-tot-xau">
      <li class="text-center">
        <h3 class="title has-text-white">
          LỊCH THÁNG {{dl.month}} NĂM {{dl.year}}
        </h3>
      </li>
      <li class="text-center position-relative">
        <div class="row">
          <div class="col-md-6 col-xs-6 col-lg-6">
            <div class="text-center" style="background: #EAFFEF;">
              <p class="red loai-lich">Lịch Dương</p>
            </div>

            <div class="lich">
              <div class="thang">
                Tháng {{dl.month}} năm {{dl.year}}
              </div>
              <div class="ngay red">
                <span class="text">{{dl.day}}</span>
              </div>
              <div class="ten-thu">
                <p>{{dl.dayName}}</p>
              </div>
              <div class="con-giap">
                <img :src="`assets/img/12congiap/${al.day.chi + 1}.png`" alt="">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-6 col-lg-6">
            <div class="text-center" style="background: #EAFFEF;">
              <p class="blue loai-lich">Lịch âm</p>
            </div>

            <div class="lich">
              <div class="thang">
                Tháng {{al.month.value}} năm {{al.year.name}}
              </div>
              <div class="ngay blue">
                <span class="text">{{al.day.value}}</span>
              </div>
              <div class="ngay-am">
                <p>Thời gian theo tiết khí</p>
                <p>Ngày : <b>{{alTk.day.name}}</b>, Tháng: <b>{{alTk.month.name}}</b>
                </p>
                <p>
                  Năm: <b> {{alTk.year.name}} </b>, Tiết <b>{{alTk.tk.name}}</b>
                </p>
                <p>Ngày khởi tiết <b>{{startTk[1]}} ngày {{startTk[0]}}</b></p>
                <p>Ngày chuyển tiết <b>{{nextTk[1]}} ngày {{nextTk[0]}}</b></p>
              </div>
            </div>
          </div>
        </div>
        <!--      <div class="level">-->
        <!--        <span class="ngay-tot">Ngày tốt</span>-->
        <!--      </div>-->
      </li>
      <!--    <li class="text-center">-->
      <!--      <h3 class="title">Giờ hoàng đạo</h3>-->
      <!--      <ul class="gio-tot-xau">-->
      <!--        <li>Dần (3h - 5h)</li>-->
      <!--        <li>Mão (5h - 7h)</li>-->
      <!--        <li>Tỵ (9h - 11h)</li>-->
      <!--        <li>Thân (15h - 17h)</li>-->
      <!--        <li>Tuất (19h - 21h)</li>-->
      <!--        <li>Hợi (21h - 23h)</li>-->
      <!--      </ul>-->
      <!--    </li>-->
      <!--    <li class="text-center">-->
      <!--      <h3 class="title">Giờ hắc đạo</h3>-->
      <!--      <ul class="gio-tot-xau">-->
      <!--        <li>Tý (23h - 1h)</li>-->
      <!--        <li>Sửu (1h - 3h)</li>-->
      <!--        <li>Thìn (7h - 9h)</li>-->
      <!--        <li>Ngọ (11h - 13h)</li>-->
      <!--        <li>Mùi (13h - 15h)</li>-->
      <!--        <li>Dậu (17h - 19h)</li>-->
      <!--      </ul>-->
      <!--    </li>-->
      <!--    <li class="text-center">-->
      <!--      <h3 class="title">Sao tốt xấu</h3>-->
      <!--      <ul class="tot-xau">-->
      <!--        <li>-->
      <!--          <b>Sao tốt : </b>-->
      <!--          Thiên ân, Mẫu thương, Minh đường-->
      <!--        </li>-->
      <!--        <li>-->
      <!--          <b>Sao xấu : </b>-->
      <!--          Tiểu hao, Qui kị-->
      <!--        </li>-->
      <!--      </ul>-->
      <!--    </li>-->
      <!--    <li class="text-center">-->
      <!--      <h3 class="title">Việc nên - Không nên làm</h3>-->
      <!--      <ul class="tot-xau">-->
      <!--        <li>-->
      <!--          <b>Nên : </b>-->
      <!--          Họp thân hữu, chăn nuôi, nạp gia súc, đuổi bắt-->
      <!--        </li>-->
      <!--        <li>-->
      <!--          <b>Không nên :</b>-->
      <!--          Đội mũ cài trâm, mở kho xuất tiền hàng, lập ước giao dịch, nạp tài, di chuyển, sửa kho, gieo trồng, khai-->
      <!--          trương, đi xa trở về-->
      <!--        </li>-->
      <!--      </ul>-->
      <!--    </li>-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LichTotXau',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dl () {
      return this.data?.dl ?? {}
    },
    al () {
      return this.data?.al ?? {}
    },
    alTk () {
      return this.data?.alTk ?? {}
    },
    startTk () {
      const tkArr = this.alTk.tk.startTk.split(' ')
      return [tkArr[0], tkArr[1]]
    },
    nextTk () {
      const tkArr = this.alTk.tk.nextKhi.split(' ')
      return [tkArr[0], tkArr[1]]
    }
  }
}
</script>

<style scoped src="../../assets/css/bootstrap2.min.css"/>
<style scoped src="../../assets/css/lichTotXau.css"/>
<style scoped>

</style>
